module.exports = __webpack_public_path__ + "img/art2.a89c1886.png";